import appConst from '../Utilities/appConst.json';
import { useContext } from 'react';
import { LanguageContext } from '../context/language/LanguageContext';
import '../styles/marketing.css';
import { Checkbox } from './ui/checkbox';
import MarketingBirthdayDatePicker from './MarketingBirthdayDatePicker';

const MarketingItem = (props) => {
    const languageContext = useContext(LanguageContext);

    return (
        <div className="marketing_item">
            <img
                className=""
                src={props.img}
                alt={props.alt}>
            </img>
            {props.img && props.img.includes(appConst.NEWSLETTER) &&
                <>
                    <div className="marketing_content" />
                    <div className="marketing_inner marketing_newslatter_container me-[15%] ms-[5%]">
                        <div className="position_flex_rtl marketing-newsletter-row">
                            <Checkbox
                                className='checkbox'
                                aria-label="newsletter"
                                checked={props.isNewsletterChecked}
                                onCheckedChange={(checked) =>
                                    props.handleNewsletterChange({
                                        target: { checked: !!checked },
                                    })
                                }
                                data-testid="marketing-newsletter-checkbox"
                            />
                            <div className="position_flex_center" style={{ fontSize: "2vh" }}>{languageContext.getTranslation(appConst.TO_NEWSLETTER)}</div>
                        </div>
                    </div>
                </>
            }
            {props.img && props.img.includes(appConst.BIRTHDAY) &&
                <>
                    <div className="marketing_content" />
                    <div className="marketing_inner marketing_birthday_container me-[15%] ms-[5%]">
                        <MarketingBirthdayDatePicker
                            value={props.birthDate}
                            onChange={props.handleCalenderChange}
                        />
                    </div>
                </>
            }
        </div>
    )
}
export default MarketingItem;
